export default "__VITE_ASSET__8e15289e__"